import type {
  CreateResult,
  DeleteResult,
  ServiceContext,
} from "@prolarus/shared";
import { tryCreate, tryDelete, toQueryString } from "./_shared";

export interface DirectPermissionAssignment {
  id: string;
  profile_id: string;
  permission_id: string;
  company_id: string;
}

// Mirrors the prior userPermissionService surface. _context / _companyId are
// preserved for signature compat; the route derives company_id from the JWT.
export const userPermissionService = {
  assign(
    profileId: string,
    permissionId: string,
    _context: ServiceContext,
  ): Promise<CreateResult<DirectPermissionAssignment>> {
    return tryCreate<DirectPermissionAssignment>("/api/profile-permissions", {
      profile_id: profileId,
      permission_id: permissionId,
    });
  },

  removeBulk(
    profileId: string,
    permissionIds: string[],
    _companyId: string,
  ): Promise<DeleteResult> {
    return tryDelete(
      `/api/profile-permissions${toQueryString({
        profile_id: profileId,
        permission_ids: permissionIds.join(","),
      })}`,
    );
  },
};
